<div class="widget-container" #pieChartDiv>
  <!-- Headings -->
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background: white;">
      <div>

        <icon-chart [headerConfig]="item.config?.widget_header_configuration" [data]="this.pieData" [pageKey]="pageKey"
          [heading]="heading" [chartName]="'pieChartDiv'" [config]="pieC" [expand]="fs" [fullscreen]="isFullscreen"
          [item]="item" (screenChanges)="screenChanges($event)" (showbyChanges)="showByChanges($event)"></icon-chart>

      </div>
<div *ngIf="item?.config?.['header_divider']">
  <hr>
</div>
      <!-- Grid -->
      <!-- <br> -->

      <div>
        <loading *ngIf="isLoading"> </loading>
      </div>

      <div style="height: 200px; width: auto; " *ngIf="noData">
        <span class="bg-text">{{ error_name ? error_name : 'There is no data for this time period' }}</span>
      </div>

      <div #pieC [style.display]="noData?'none':''">
        <div class="mains" [ngStyle]="{'flex-direction':item?.config?.['legend_position']?.['value']=='bottom' ?'column':'row'}" *ngIf="this.isDataLoaded" >

          <div class="chart" [style.height]="isFullscreen ? '100%' : this.item?.config?.width+'px'" >
           <div style="display: flex;align-items: anchor-center;">
                <div style="width:40%;min-width:180px" *ngIf="this.item?.config?.['statusCard']||false">
                  <app-stat-card [stats]="therapyStats"></app-stat-card>
                </div>
                <div [ngStyle]="{width:item?.config?.['statusCard']?'60%':'100%'}">
              <div class="total" *ngIf="this.item?.config?.['total_on_center']||false" >
              <div *ngIf="chartType == 'pieChart'" class="label">Total</div>
              <div *ngIf="chartType == 'pieChart'" class="value">{{ total }} records</div>
              <div [id]='DonutId+"pie"' class="chart-container"></div>
            </div>
                  <div [id]='DonutId'  class="chart-container"></div>
                </div>
                <!-- <duc-tooltip [config]=" $any(config.tooltip)" [data]="data"></duc-tooltip> -->
             </div>
          
            <!-- <duc-tooltip [config]=" $any(config.tooltip)" [data]="data"></duc-tooltip> -->
          </div>

          <div class="legend" style="width: 100%; overflow: auto;" [ngStyle]="{
  'flex-direction': (item?.config?.['legend_direction']?.['value'] === 'column') ? 'column' : 'row',
  'flex-wrap': (item?.config?.['legend_direction']?.['value'] === 'column') ? 'wrap' : 'nowrap',
  'height': (item?.config?.legend_height || 200) + 'px'
   }">
            <div *ngFor="let item of legendData" class="group">
              <button class="color" [style]="'background: ' + item.color + ';border-color: ' + item.color"
                (click)="test(item)">&nbsp;</button>
              <div class="text">
                <span class="label">{{ item.label }}</span>
                <span *ngIf="item.info" class="info">{{ item.info }}</span>
              </div>

            </div>

          </div>

        </div>
      </div>
      
       <ng-template #pieChartTooltip>
            <div id="d3pieTooltip">
                  <div class="container chart_tooltip"  >
                    <div class="row chart_tooltip_header">
                      <div class="col-12 d-flex flex-column">
                        <div class="chart_tooltip_header_heading mt-1">
                          {{ item?.config?.static_header  ? heading : getQuarter(filterService.baseQuery?.from_date) }}
                        </div>
                       
                      </div>
                    </div>
                    <div class="mt-2 mb-5" [ngClass]="(dataTurn < 100 ) ? 'chart_tooltip_body-after' :'chart_tooltip_body'">
                      <div class=" mt-1 pb-1" >
                      
                          <div class="w-100 d-flex   align-items-left"  >
                         
                            <div>
                              <div class="tooltip_outlay" [style.background]="mytooltipData.color" ></div>
                            </div>
                            <div class="chart_tooltip_body_data ml-2">{{mytooltipData?.category||mytooltipData?.label }} : {{numbedPipe(mytooltipData?.value||0)}}</div>
                            
                          </div>
                      </div>
                    </div>
          
                  </div>
                </div> 
              </ng-template>
    </article>
  </main>
</div>